// 主对象列表使用新接口
import { reactive, toRefs } from 'vue';
import { tableService, setService, layoutService, publicService } from '@/api/';
import { useFilterListStore } from '@/store';
// import { tools } from '@/utils/tools'; //工具函数
// import { Message } from '@arco-design/web-vue';
export default function useMainTable() {
  const data = reactive({
    dropdownFieldList: [], //下拉筛选字段
    buttonUniversal: [], //通用按钮
    dropdownLoading: true, //下拉筛选字段loading
    groupSortLoading: true, //分组和排序loading
    highConditionsLoading: true, //系统检索及自定义检索列表loading
    buttonBatch: [], //批量按钮
    batchBtnPermission: [], //批量按钮权限
    buttonShortcut: [], //快捷按钮
    shortcutBtnPermission: [], //快捷按钮权限
    nestColumnField: {}, //嵌套字段表头数据
    conditionsType: {}, //筛选字段的条件类型
    allFieldsList: [], //对象下所有字段
    allFieldsListObj: {}, //对象下所有字段以fieldKey为键，以该字段对象为值的..键值对对象
    groupFieldList: [], //分组字段
    highConditionsList: [] //系统检索及自定义检索列表
  });
  const useFilterList = useFilterListStore();

  // 获取下拉筛选字段和通用按钮
  const getFilterAndUniversalBtn = async (params) => {
    data.dropdownFieldList = [];
    data.buttonUniversal = [];
    data.dropdownLoading = true;
    if (params.entity && params.viewId) {
      try {
        const json = await tableService.getFilterAndUniversalBtn(params);
        const res = json.result;
        data.dropdownFieldList = res?.dropdowns || [];
        data.buttonUniversal = res?.buttonUniversal || [];
        data.dropdownLoading = false;
        return res;
      } catch (e) {
        console.log(277, e);
        data.dropdownLoading = false;
        return [];
      }
    } else {
      return [];
    }
  };
  // 获取批量按钮和快捷按钮
  const getBatchAndQuickBtn = async (params) => {
    data.buttonBatch = [];
    data.buttonShortcut = [];
    if (params.entity && params.viewId) {
      try {
        const json = await tableService.getBatchAndQuickBtn(params);
        const res = json.result;
        data.buttonBatch = res?.buttonBatch || [];
        data.buttonShortcut = res?.buttonShortcut || [];
        data.shortcutBtnPermission = data?.buttonShortcut.map((item) => item.value); //快捷按钮权限
        data.batchBtnPermission = data?.buttonBatch.map((item) => item.value);
        return res;
      } catch (e) {
        console.log(288, e);
        return [];
      }
    } else {
      return [];
    }
  };
  // 获取嵌套字段表头数据
  const getNestField = async (params) => {
    if (params.entity && params.viewId) {
      data.nestColumnField = {};
      try {
        const json = await tableService.getNestField(params);
        const res = json.result;
        data.nestColumnField = res || {};
        return res;
      } catch (e) {
        console.log(298, e);
        return [];
      }
    } else {
      return [];
    }
  };
  // 获取字段条件选项
  const getFieldsConditions = async () => {
    data.conditionsType = {};
    try {
      const json = await setService.getDynamic();
      if (json.error) return; // 错误拦截
      json.result?.forEach((item) => {
        data.conditionsType[item.fieldType] =
          item.fieldType === 24
            ? item.computeMaps // 计算字段24的特殊类型处理
            : item.conditions; // 其他类型的处理
      });
    } catch (e) {
      console.log(e);
    }
  };
  // 获取对象下所有字段并处理
  const getAllFields = async (params) => {
    if (!params?.entity) return [];
    data.allFieldsList = [];
    data.allFieldsListObj = {};
    try {
      const { error, result } = await setService.getEntitySettings(params);
      if (error) return; // 错误拦截
      // const filteredFields = result?.filter((field) => field.fieldType !== 18 && !(field.fieldType === 21 && field.business?.fieldType === 18));
      data.allFieldsList = result; // 获取字段列表(此处去除了---过滤附件类型逻辑)
      if (!result || !result.length) return;
      for (const field of result) {
        try {
          const target = field.fieldType === 10 ? field : field.business?.fieldType === 10 ? field.business : null;
          if (target?.fieldExt) {
            // 直接处理JSON解析和转换，避免中间变量
            target.fieldExt = JSON.stringify(
              Object.entries(typeof target.fieldExt === 'string' ? JSON.parse(target.fieldExt) : target.fieldExt).reduce((acc, [key, value]) => {
                acc[key === 'isEnabled' ? 'disabled' : key] = key === 'isEnabled' ? !value : value;
                return acc;
              }, {})
            );
          }
          data.allFieldsListObj[field.fieldKey] = field;
        } catch (error) {
          console.error(`字段处理失败 [${field.fieldKey}]:`, error);
        }
      }
    } catch (error) {
      console.error('获取字段失败:', error);
    }
  };
  // 获取检索筛选列表
  const getConditionList = async (params) => {
    if (!params.entity) return [];
    try {
      const json = await publicService.getConditionList(params);
      if (!json.error) {
        data.highConditionsList = json.result;
        data.highConditionsLoading = false;
        return json.result;
      } else {
        return [];
      }
    } catch (e) {
      console.log(977, e);
      data.highConditionsLoading = false;
      return [];
    }
  };
  // 获取分组和排序信息
  const getGroupAndSortInfo = async (params) => {
    try {
      const { entity } = params;
      const { setFieldsSort, setFieldsSortDefault, setSortId } = useFilterList;
      // 重置状态
      setFieldsSort([]);
      setFieldsSortDefault([]);
      const json = await layoutService.userListPageConfigGet(params);
      if (json.error) {
        console.log(json.error?.msg || '失败，请重试!');
        return;
      }
      const { result: res } = json;
      // 处理分组字段并过滤
      data.groupFieldList = res.fieldGroups || [];
      // 优化排序字段处理 - 合并循环
      const defaultSortList = res?.defaultSortList || [];
      const sortList = res?.sortList || [];
      // 使用Map去重并合并排序字段 (如果有重复fieldKey，自定义排序优先)
      const sortMap = new Map();
      const defaultSortMap = new Map();
      // 先处理默认排序字段
      defaultSortList.forEach((item) => {
        if (item.fieldStatus === 1) {
          defaultSortMap.set(item.fieldKey, { ...item, isDefault: true });
        }
      });
      // 再处理自定义排序字段，会覆盖默认排序
      sortList.forEach((item) => {
        if (item.fieldStatus === 1) {
          sortMap.set(item.fieldKey, { ...item, isDefault: false });
        }
      });
      // 转换Map为数组
      const mergedSortFields = Array.from(sortMap.values());
      const mergedDefaultSortFields = Array.from(defaultSortMap.values());
      // 设置排序字段：优先使用自定义排序，否则使用默认排序
      setFieldsSort(mergedSortFields.length ? mergedSortFields : mergedDefaultSortFields);
      setFieldsSortDefault(mergedDefaultSortFields);
      // 保存排序ID
      if (res?.id) {
        setSortId(entity.value, res.id);
      }
      data.groupSortLoading = false;
    } catch (e) {
      console.log(e);
      data.groupSortLoading = false;
    }
  };
  const setGroupFieldsInfo = (groupFields) => {
    data.groupFieldList = groupFields;
  };
  return {
    getFilterAndUniversalBtn,
    getBatchAndQuickBtn,
    getNestField,
    getFieldsConditions,
    getAllFields, // 获取对象下所有字段
    getGroupAndSortInfo, // 获取分组和排序信息
    getConditionList, // 获取检索筛选列表
    setGroupFieldsInfo, //更新分组字段信息
    ...toRefs(data)
  };
}
